import cookies from 'vue-cookies';

const sleep = (ms) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  new Promise((res) => {
    setTimeout(res, ms);
  });

function setCookie(key, value, validade) {
  const urlApplication = key === 'PublicToken' ? 'vr.app.br' : process.env.VUE_APP_COOKIE_URL;
  const pathApplication = '/';
  const diasValidadeCookie = validade || '6d';
  cookies.set(key, value, diasValidadeCookie, pathApplication, urlApplication);
}

export default {
  sleep,
  setCookie,
};
